<template>
  <v-dialog v-model="modalOpen" persistent max-width="80%">
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between primary white--text">
        Detalles de la Actividad de {{ getStudentName() }}
        <v-spacer></v-spacer>
        <v-btn color="red" @click="$emit('update:modalOpen', false)">
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <v-tabs v-model="tab">
            <v-tab href="#tab-1">Párrafos</v-tab>
            <v-tab href="#tab-2">Respuestas</v-tab>
            <v-tab href="#tab-3">Palabras Guardadas</v-tab>
          </v-tabs>
          <v-tabs-items touchless v-model="tab">
            <v-tab-item value="tab-1">
              <v-card-title>
                <p class="text-justify">Tiempo de lectura: <strong>{{ formatTime(this.timeread) }} segundos</strong></p>
              </v-card-title>
              
              <!-- Texto normal sin minijuego -->
              <v-card class="mt-4" width="100vw" v-if="minigameName === null">
                <v-card-text>
                  <v-container fluid>
                    <v-row class="scrollable-content--large">
                      <v-col class="text--primary" v-for="(paragraph, i) in highlightedParagraphs" :key="i" cols="12">
                        <p class="text-justify" style="font-size: 16px;" v-html="paragraph.description"></p>
                        <v-text-field readonly
                          v-if="paragraphAnswer[i].answer"
                          :prepend-icon="hasAnswer(paragraphAnswer[i]) ? 'mdi-check-all' : 'mdi-close'"
                          :value="hasAnswer(paragraphAnswer[i]) ? paragraphAnswer[i].answer : 'Estudiante no realizó pregunta.'" />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              
              <!-- Minijuego de imágenes -->
              <v-card class="mt-4" width="100vw" v-if="minigameName === 'image_minigame'">
                <v-card-text>
                  <v-container class="scrollable-content--large">
                    <div v-for="(paragraph, i) in highlightedParagraphs" :key="i">
                      <v-row class="ma-0 pa-0">
                            <!-- Área del texto del párrafo -->
                            <v-col cols="12" md="7" class="pa-4">
                              <p class="text--primary book-paragraph" v-html="paragraph.description"></p>
                              <v-text-field readonly
                                :prepend-icon="hasAnswer(paragraphAnswer[i]) ? 'mdi-check-all' : 'mdi-close'"
                                :value="hasAnswer(paragraphAnswer[i]) ? paragraphAnswer[i].answer : 'Estudiante no realizó pregunta.'" />
                       </v-col>
                          <v-col  cols="12" md="4" class="pa-4 d-flex flex-column align-center justify-center">
                            <div :class="['image-container', getImageBorderClass(paragraph.id)]">
                                <v-img 
                                  v-if="getStudentImageSelection(paragraph.id) =='valid_image'" 
                                  :src="getStudentImage(paragraph.id)" 
                                  class="contained-image"
                                  contain
                                  max-height="250"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                                <!-- Caso: El estudiante seleccionó "Ninguna imagen" (null) -->
                                <v-card 
                                  v-else-if="getStudentImageSelection(paragraph.id) === 'none_selected'" 
                                  class="contained-image d-flex justify-center align-center"
                                  outlined
                                >
                                  <div class="no-image-option pa-2" height="250" >
                                    <v-icon size="48" color="grey lighten-1">mdi-image-off</v-icon>
                                    <h4 class="grey--text text--lighten-1 mt-2">Ninguna imagen</h4>
                                    <p class="caption grey--text">Estudiante seleccionó: "Ninguna imagen"</p>
                                  </div>
                                </v-card>
                                
                                <!-- Caso: El estudiante no respondió (no_response) -->
                                <v-card 
                                  v-else-if="getStudentImageSelection(paragraph.id) === 'no_response'" 
                                  class="contained-image d-flex justify-center align-center"
                                  color="orange lighten-4"
                                  outlined
                                >
                                  <div class="no-image-option pa-2" height="250">
                                    <v-icon size="48" color="orange">mdi-help-circle-outline</v-icon>
                                    <h4 class="orange--text text--darken-2 mt-2">Sin respuesta</h4>
                                    <p class="caption orange--text text--darken-1">El estudiante no seleccionó ninguna opción</p>
                                  </div>
                                </v-card>
                            </div>

                        </v-col>
                      </v-row>
                    </div>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- Minijuego de texto desordenado -->
              <v-card class="mt-4" width="100vw" v-if="minigameName === 'unordered_text'">
                <v-card-text>
                  <v-container class="scrollable-content--large" fluid>
                    <v-row>
                      <v-col cols="6">
                        <v-card-title class="d-flex justify-center">
                          <strong>Orden correcto</strong>
                        </v-card-title>
                      </v-col>
                      <v-col cols="6"> 
                        <v-card-title class="d-flex justify-center">
                          <strong>Orden estudiante</strong>
                        </v-card-title>
                      </v-col>
                    </v-row>
                    <v-row v-for="(paragraph, i) in highlightedParagraphs" :key="i">
                      <v-col class="text--primary" cols="6">
                        <p class="text-justify" style="font-size: 16px;" v-html="paragraph.description"></p>
                      </v-col>
                      <v-col class="text--primary" cols="6">
                        <p class="text-justify" style="font-size: 16px;" 
                           :style="{ color: paragraph.id === order[i] ? 'green' : 'red' }"
                           v-html="getOrderedParagraph(i)"></p>
                        <v-text-field readonly
                          :prepend-icon="hasAnswer(paragraphAnswer[i]) ? 'mdi-check-all' : 'mdi-close'"
                          :value="hasAnswer(paragraphAnswer[i]) ? paragraphAnswer[i].answer : 'Estudiante no realizó pregunta.'" />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <v-card-title>
                <p class="text-justify">Tiempo de respuesta: <strong>{{ formatTime(this.time )}} segundos</strong></p>
              </v-card-title>

              <div class="scrollable-content--large" fluid>
                <v-card  v-for="(question, index) in questions" :key="index"  width="100vw">
                  <v-card-title class="primary white--text">
                    <div class="text-justify">
                      {{index + 1}}) {{ question.question.title }} ({{calculateScore(question, index)}}pts)
                    </div>
                    <v-card-text>
                      <div class="text-justify description-content ma-2" v-if="question.question.description && question.question.description.length > 0">
                        {{ question.question.description }}
                      </div>
                      <p class="text-justify">
                        Tiempo que se demoró en la pregunta: {{ getTimeFromId(question.question.id) }} segundos 
                      </p>
                    </v-card-text>
                  </v-card-title>
                
                  
                  <!-- Respuestas de desarrollo (tipo 0) -->
                  <v-container class="pa-5" fluid v-if="question.question.type === 0">
                    <div v-if="isAnswerNull(index)" >
                      <v-alert class="pa-3 warning lighten-4" dense>
                        No se respondió esta pregunta
                      </v-alert>
                    </div>
                    <div v-else disabled class="light-blue lighten-4" color="teal">
                      <p class="pa-5" text-color="primary">
                        Respuesta: {{ getAnswerText(index) }}
                      </p>
                    </div>
                    
                    <!-- Mostrar evaluación AI si existe -->
                    <v-card 
                      v-if="!isAnswerNull(index) && hasAIScore(index)"
                      class="mt-3 pa-3"
                      outlined
                    >
                      <v-card-title class="subtitle-1">
                        Evaluación automatizada: {{ getAIScore(index) }}/{{ question.question.points }} pts
                      </v-card-title>
                      <v-card-text v-if="getAIExplanation(index)">
                        {{ getAIExplanation(index) }}
                      </v-card-text>
                    </v-card>
                  </v-container>

                  <!-- Respuestas de selección única (tipo 1) -->
                  <v-container class="pa-5" fluid v-if="question.question.type === 1">
                    <div v-if="isAnswerNull(index)" >
                      <v-alert class="pa-3 warning lighten-4" dense>
                          No se respondió esta pregunta
                        </v-alert>
                    </div>
                    <v-radio-group v-else>
                      <v-radio disabled v-for="(alternative, i) in question.question.answer" :key="i" color="red"
                        :off-icon="getIcon(alternative, getAnswerObject(index))">
                        <template v-slot:label>
                          <h4 v-if="
                            isAnswerEqualToAlternative(index, alternative) &&
                            alternative.isCorrect
                          " class="text-left" style="color: green">
                            {{ alternative.description }} (Respuesta correcta)
                          </h4>
                          <h4 v-else-if="
                            isAnswerEqualToAlternative(index, alternative) &&
                            !alternative.isCorrect
                          " class="text-left" style="color: red">
                            {{ alternative.description }}
                          </h4>
                          <h4 v-else class="text-left"
                            :style="{ color: alternative.isCorrect ? 'green' : '' }">
                            {{ alternative.isCorrect ? `${alternative.description} (Respuesta correcta)` :
                            alternative.description }}
                          </h4>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-container>

                  <!-- Respuestas de selección múltiple (tipo 2) -->
                  <v-container class="pa-5" fluid v-if="question.question.type === 2">
                    <div v-if="isAnswerNull(index)" >
                      <v-alert class="pa-3 warning lighten-4" dense>
                        No se respondió esta pregunta
                      </v-alert>
                    </div>
                    <v-checkbox v-else disabled v-for="(alternative, i) in question.question.answer" :key="i"
                      :label="alternative.description" :value="alternative"
                      :off-icon="getIconMultiple(alternative, questionAnswers[index])">
                      <template v-slot:label>
                        <h4 v-if="
                          isOptionSelected(index, alternative.id) && 
                          alternative.isCorrect
                        " class="text-left" style="color: green">
                          {{ alternative.description }} (Respuesta Correcta)
                        </h4>
                        <h4 v-else-if="
                          isOptionSelected(index, alternative.id) && 
                          !alternative.isCorrect
                        " class="text-left" style="color: red">
                          {{ alternative.description }}
                        </h4>
                        <h4 v-else class="text-left"
                          :style="{ color: alternative.isCorrect ? 'green' : '' }">
                          {{ alternative.isCorrect ? `${alternative.description} (Respuesta correcta)` :
                          alternative.description }}
                        </h4>
                      </template>
                    </v-checkbox>
                  </v-container>
                </v-card>
              </div>

            </v-tab-item>
            
            <v-tab-item value="tab-3">
              <v-card elevation="2" class="mt-10" width="100vw">
                <v-card-title>Palabras Guardadas</v-card-title>
                <v-spacer></v-spacer>
                <v-row class="ml-2">
                  <v-col cols="6" v-for="(word, i) in savedWords" :key="i">
                    <v-text-field label="Palabra" :value="word" readonly />
                  </v-col>
                  <p v-if="!savedWords || savedWords.length === 0">Estudiante no guardó palabras.</p>
                </v-row>
              </v-card>
              <v-card class="mt-10" width="100vw">
                <v-card-title>Palabras Destacadas</v-card-title>
                <v-row class="ml-2">
                  <v-col cols="6" v-for="(highlight, i) in formattedHighlights" :key="i">
                    <v-text-field label="Palabra" :value="highlight" readonly />
                  </v-col>
                  <p v-if="!formattedHighlights || formattedHighlights.length === 0">Estudiante no resaltó palabras.</p>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import axios from "axios";

export default {
  props: ['minigameName', 'idActividad', 'idEstudiante', 'modalOpen'],
  data() {
    return {
      order: [],
      savedWords: [],
      highLight: [],
      reply: null,
      paragraphAnswer: null,
      questionAnswers: null,
      tab: null,
      paragraphs: [],
      highlightedParagraphs: [], // Nueva propiedad para los párrafos con resaltado
      questions: [],
      time: '',
      timeread: '',
      timeAnswer: [],
      minigameInfo: null
    }
  },
  computed: {
    // Formatea las palabras destacadas para mostrarlas
    formattedHighlights() {
      if (!this.highLight || !Array.isArray(this.highLight)) return [];
      
      return this.highLight.map(highlight => {
        if (typeof highlight === 'string') {
          return highlight;
        } else if (typeof highlight === 'object' && highlight.text) {
          return highlight.text;
        }
        return JSON.stringify(highlight);
      });
    }
  },
  methods: {
    formatTime(seconds) {
        if (!seconds || seconds < 0) return 'N/A';

        const totalSeconds = Math.floor(seconds); // Redondear correctamente
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return minutes > 0
        ? `${minutes}m${remainingSeconds}s`
        : `${remainingSeconds}s`;
      },
    // Obtener nombre del estudiante con manejo de errores
    getStudentName() {
      try {
        return this.reply && this.reply.student 
          ? `${this.reply.student.name} ${this.reply.student.lastName}` 
          : 'Estudiante';
      } catch (e) {
        return 'Estudiante';
      }
    },

    getStudentImage(paragraphId) {
      if (this.minigameInfo != null) {
        return this.minigameInfo[paragraphId] || null;
      }
      return null;
    },

    getStudentImageSelection(paragraphId) {
      const studentSelection = this.getStudentImage(paragraphId);
      
      if (studentSelection === 'no_response') {
        return 'no_response';
      } else if (studentSelection === null) {
        return 'none_selected';
      } else if (studentSelection && typeof studentSelection === 'string' && studentSelection.length > 0) {
        return 'valid_image';
      } else {
        return 'error';
      }
    },
    getImageBorderClass(paragraphId) {
      const studentSelection = this.getStudentImage(paragraphId);
      const correctImage = this.paragraphs.find(p => p.id === paragraphId)?.image;
      
      // Si el estudiante no respondió, mostrar como incorrecto
      if (studentSelection === 'no_response') {
        return 'incorrect-answer';
      }
      
      // Si el estudiante seleccionó "ninguna imagen" y la respuesta correcta también es null/undefined
      if (studentSelection === null && !correctImage) {
        return 'correct-answer';
      }
      
      // Comparación normal
      return studentSelection === correctImage ? 'correct-answer' : 'incorrect-answer';
    },
    
    
    // Verificar si una respuesta existe
    hasAnswer(question) {
      return question && question.answer !== null && question.answer !== undefined && question.answer !== '';
    },
    
    // Verificar si una respuesta es nula
    isAnswerNull(index) {
      try {
        return !this.questionAnswers || 
               !this.questionAnswers[index] || 
               this.questionAnswers[index].answer === null;
      } catch (e) {
        console.error('Error al verificar respuesta nula:', e);
        return true;
      }
    },
    
    // Obtener el texto de la respuesta para preguntas de desarrollo
    getAnswerText(index) {
      try {
        if (this.isAnswerNull(index)) return 'No respondido';
        
        const answer = this.questionAnswers[index].answer;
        if (typeof answer === 'string') return answer;
        if (typeof answer === 'object' && answer.description) return answer.description;
        
        return JSON.stringify(answer);
      } catch (e) {
        console.error('Error al obtener texto de respuesta:', e);
        return 'Error al cargar respuesta';
      }
    },
    
    // Verificar si la respuesta tiene puntuación AI
    hasAIScore(index) {
      try {
        return this.questionAnswers[index] && 
               this.questionAnswers[index].aiScore !== undefined;
      } catch (e) {
        return false;
      }
    },
    
    // Obtener la puntuación AI
    getAIScore(index) {
      try {
        return this.questionAnswers[index].aiScore;
      } catch (e) {
        return 0;
      }
    },
    
    // Obtener la explicación AI
    getAIExplanation(index) {
      try {
        return this.questionAnswers[index].explanation || '';
      } catch (e) {
        return '';
      }
    },
    
    // Obtener el objeto de respuesta para tipo 1
    getAnswerObject(index) {
      try {
        if (this.isAnswerNull(index)) return { id: null, isCorrect: false };
        return this.questionAnswers[index].answer || { id: null, isCorrect: false };
      } catch (e) {
        console.error('Error al obtener objeto de respuesta:', e);
        return { id: null, isCorrect: false };
      }
    },
    
    // Verificar si la respuesta seleccionada es igual a la alternativa
    isAnswerEqualToAlternative(index, alternative) {
      try {
        if (this.isAnswerNull(index)) return false;
        
        const answer = this.questionAnswers[index].answer;
        return answer && answer.id === alternative.id;
      } catch (e) {
        console.error('Error al comparar respuesta con alternativa:', e);
        return false;
      }
    },
    
    // Verificar si una opción está seleccionada en respuestas múltiples
    isOptionSelected(index, alternativeId) {
      try {
        if (this.isAnswerNull(index)) return false;
        
        const answers = this.questionAnswers[index].answer;
        if (!Array.isArray(answers)) return false;
        
        return answers.some(answer => answer.id === alternativeId);
      } catch (e) {
        console.error('Error al verificar opción seleccionada:', e);
        return false;
      }
    },
    
    // Obtener párrafo ordenado con manejo de errores
    getOrderedParagraph(index) {
      try {
        if (!this.order || !Array.isArray(this.order) || !this.order[index]) {
          return 'Orden no disponible';
        }
        
        const orderId = this.order[index];
        const paragraph = this.highlightedParagraphs.find(p => p.id === orderId);
        
        return paragraph ? paragraph.description : 'Párrafo no encontrado';
      } catch (e) {
        console.error('Error al obtener párrafo ordenado:', e);
        return 'Error al cargar párrafo';
      }
    },
    
    // Obtener imagen con manejo de errores
    getImage(id) {
      try {
        if (!this.minigameInfo) return null;
        
        const image = this.minigameInfo[id];
        return image || null;
      } catch (e) {
        console.error('Error al obtener imagen:', e);
        return null;
      }
    },
    
    // Obtener clase de borde con manejo de errores
    getBorderClass(paragraphId) {
      try {
        if (!this.minigameInfo) return '';
        
        const studentImage = this.minigameInfo[paragraphId];
        const paragraph = this.paragraphs.find(p => p.id === paragraphId);
        
        if (!paragraph) return '';
        
        const correctImage = paragraph.image;
        return studentImage === correctImage ? 'correct-answer' : 'incorrect-answer';
      } catch (e) {
        console.error('Error al obtener clase de borde:', e);
        return '';
      }
    },
    
    // Obtener ícono para preguntas de selección única
    getIcon(alternative, answer) {
      try {
        if (!answer || answer.id === null) return "mdi-checkbox-blank-circle-outline";
        
        if (alternative.id === answer.id && alternative.isCorrect) {
          return "mdi-check-circle";
        }
        if (alternative.id === answer.id && !alternative.isCorrect) {
          return "mdi-close-circle";
        }
        return "mdi-checkbox-blank-circle-outline";
      } catch (e) {
        console.error('Error en getIcon:', e);
        return "mdi-checkbox-blank-circle-outline";
      }
    },
    
    // Obtener ícono para preguntas de selección múltiple
    getIconMultiple(alternative, answer) {
      try {
        if (!answer || !answer.answer || !Array.isArray(answer.answer)) {
          return "mdi-checkbox-blank-outline";
        }
        
        if (
          answer.answer.some((val) => val.id === alternative.id) &&
          alternative.isCorrect
        ) {
          return "mdi-checkbox-marked";
        }
        if (
          answer.answer.some((val) => val.id === alternative.id) &&
          !alternative.isCorrect
        ) {
          return "mdi-close-box";
        }
        return "mdi-checkbox-blank-outline";
      } catch (e) {
        console.error('Error en getIconMultiple:', e);
        return "mdi-checkbox-blank-outline";
      }
    },
    
    // Calcular puntuación con manejo de errores
    calculateScore(question, index) {
      try {
        // Si no hay respuesta, el puntaje es 0
        if (this.isAnswerNull(index)) {
          return `0/${question.question.points}`;
        }
        
        // Preguntas de desarrollo con evaluación AI
        if (question.question.type === 0 && this.hasAIScore(index)) {
          const score = this.getAIScore(index);
          return `${score}/${question.question.points}`;
        }
        
        // Preguntas de selección múltiple (tipo 2)
        if (question.question.type === 2) {
          const correctAnswers = question.question.answer.filter(a => a.isCorrect);
          const studentAnswers = this.questionAnswers[index].answer;
          
          // Verificar que studentAnswers sea un array
          if (!Array.isArray(studentAnswers)) {
            return `0/${question.question.points}`;
          }
          
          // Verificar que todas las respuestas correctas estén seleccionadas
          const allCorrect = correctAnswers.every(correctAnswer => 
            studentAnswers.some(studentAnswer => 
              studentAnswer.id === correctAnswer.id && studentAnswer.isCorrect
            )
          );
          
          // Verificar que no haya respuestas incorrectas seleccionadas
          const noIncorrect = !studentAnswers.some(studentAnswer => !studentAnswer.isCorrect);
          
          return (allCorrect && noIncorrect) ? 
            `${question.question.points}/${question.question.points}` : 
            `0/${question.question.points}`;
        } 
        
        // Preguntas de selección única (tipo 1)
        if (question.question.type === 1) {
          const answer = this.questionAnswers[index].answer;
          if (!answer) return `0/${question.question.points}`;
          
          return answer.isCorrect ?
            `${question.question.points}/${question.question.points}` : 
            `0/${question.question.points}`;
        }
        
        // Tipo de pregunta desconocido
        return `0/${question.question.points}`;
      } catch (e) {
        console.error('Error al calcular puntaje:', e);
        return `0/${question.question.points}`;
      }
    },
    
    // Obtener tiempo de respuesta con manejo de errores
    getTimeFromId(id) {
      try {
        if (!this.timeAnswer || !Array.isArray(this.timeAnswer)) return '0.00';
        
        // Encontrar el objeto en timeAnswer que tenga el id coincidente
        const timeObj = this.timeAnswer.find(val => val.id === id);
        if (!timeObj) return '0.00';
        
        const time = parseFloat(timeObj.time);
        return isNaN(time) ? '0.00' : time.toFixed(2);
      } catch (error) {
        console.error('Error al analizar tiempo:', error);
        return '0.00'; // Valor predeterminado en caso de error
      }
    },
    
    // Sumar tiempos de respuesta con manejo de errores
    getTimeAnswer(timeAnswer) {
      try {
        // Si es string, intentar parsear
        if (typeof timeAnswer === 'string') {
          try {
            timeAnswer = JSON.parse(timeAnswer);
          } catch (e) {
            console.error('Error al parsear tiempo de respuesta:', e);
            return 0;
          }
        }
        
        // Verificar si timeAnswer es un array y no está vacío
        if (!Array.isArray(timeAnswer) || timeAnswer.length === 0) {
          return 0; // Devolver 0 si no hay tiempos para sumar
        }

        // Usar reduce para sumar todos los tiempos
        const total = timeAnswer.reduce((accumulator, currentValue) => {
          // Validar que currentValue.time sea un número
          const time = parseFloat(currentValue.time) || 0;
          return accumulator + time;
        }, 0);

        return total; // Devolver la suma total de los tiempos
      } catch (error) {
        console.error('Error al analizar tiempos de respuesta:', error);
        return 0; // Devolver 0 en caso de error
      }
    },
    
    // Aplicar resaltado al texto con soporte para formatos antiguo y nuevo
    applyHighlightsToText(paragraphs) {
      if (!paragraphs || !Array.isArray(paragraphs)) return [];
      
      return paragraphs.map(p => {
        let description = p.description;
        
        // Verificar que highLight sea válido
        if (this.highLight && Array.isArray(this.highLight)) {
          // Procesar cada resaltado
          this.highLight.forEach(highlight => {
            // Si el resaltado es un objeto con el formato nuevo
            if (typeof highlight === 'object' && highlight !== null) {
              // Solo aplicar a este párrafo específico
              if (highlight.paragraphId == p.id) {
                // Obtener el texto a resaltar
                const cleanPhrase = highlight.text.replace(/<\/?[^>]+(>|$)/g, "");
                const escaped = this.escapeRegExp(cleanPhrase);
                
                // Encontrar la ocurrencia específica
                let count = 0;
                const regex = new RegExp(`(${escaped})`, 'gi');
                description = description.replace(regex, (match) => {
                  if (count === highlight.occurrenceIndex) {
                    count++;
                    return `<span class="highlight-word">${match}</span>`;
                  }
                  count++;
                  return match;
                });
              }
            } 
            // Si es formato antiguo (string)
            else if (typeof highlight === 'string') {
              const cleanPhrase = highlight.replace(/<\/?[^>]+(>|$)/g, "");
              const escaped = this.escapeRegExp(cleanPhrase);
              const regex = new RegExp(`(${escaped})`, 'gi');
              description = description.replace(regex, '<span class="highlight-word">$1</span>');
            }
          });
        }
        
        return { ...p, description };
      });
    },
    
    // Escapar caracteres especiales para uso en regex
    escapeRegExp(string) {
      if (!string || typeof string !== 'string') return '';
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                  .replace(/\s+/g, '\\s+'); // Hacer que los espacios sean flexibles
    },
  },

  async created() {
    try {
      let textId;
      let idActivity = this.idActividad;
      let idStudent = this.idEstudiante;

      // Cargar detalles de la respuesta
      const replyResponse = await axios.get('teacher/reply/' + idStudent + '/' + idActivity);
      const { reply } = replyResponse.data;
      
      this.reply = reply;
      
      // Procesar datos con manejo de errores
      try {
        this.savedWords = JSON.parse(reply.saveWord);
      } catch (e) {
        console.error('Error al parsear palabras guardadas:', e);
        this.savedWords = [];
      }
      
      try {
        this.paragraphAnswer = JSON.parse(reply.question);
      } catch (e) {
        console.error('Error al parsear preguntas de párrafo:', e);
        this.paragraphAnswer = [];
      }
      
      try {
        this.highLight = JSON.parse(reply.highLight);
      } catch (e) {
        console.error('Error al parsear resaltados:', e);
        this.highLight = [];
      }
      
      textId = this.paragraphAnswer && this.paragraphAnswer[0] ? this.paragraphAnswer[0].textId : null;
      
      try {
        this.questionAnswers = JSON.parse(reply.answer);
      } catch (e) {
        console.error('Error al parsear respuestas:', e);
        this.questionAnswers = [];
      }
      
      let timeAnswerJSON;
      try {
        timeAnswerJSON = JSON.parse(reply.timeAnswer);
      } catch (e) {
        console.error('Error al parsear tiempos de respuesta:', e);
        timeAnswerJSON = [];
      }
      
      const timeA = this.getTimeAnswer(timeAnswerJSON);
      this.timeAnswer = timeAnswerJSON;
      this.timeread = parseFloat((reply.time - timeA).toFixed(2));
      this.time = parseFloat(timeA.toFixed(2));
      
      try {
        this.order = JSON.parse(reply.order);
      } catch (e) {
        console.error('Error al parsear orden:', e);
        this.order = [];
      }
      
      try {
        this.minigameInfo = JSON.parse(reply.minigame_info);
      } catch (e) {
        console.error('Error al parsear información de minijuego:', e);
        this.minigameInfo = null;
      }

      // Cargar texto y párrafos
      if (textId) {
        try {
          const textResponse = await axios.get('teacher/text/' + textId);
          const { text } = textResponse.data;
          this.textType = text.type;
          this.paragraphs = text.paragraph || [];
          
          // Aplicar resaltado a los párrafos
          this.highlightedParagraphs = this.applyHighlightsToText(this.paragraphs);
        } catch (e) {
          console.error('Error al cargar texto:', e);
          this.paragraphs = [];
          this.highlightedParagraphs = [];
        }
      }

      // Cargar preguntas de la actividad
      try {
        const activityResponse = await axios.get('teacher/activity/' + idActivity);
        const { questions } = activityResponse.data;
        this.questions = questions || [];
      } catch (e) {
        console.error('Error al cargar preguntas de la actividad:', e);
        this.questions = [];
      }
    } catch (e) {
      console.error('Error general al cargar datos:', e);
    }
  }
}
</script>